import { render, staticRenderFns } from "./Compensation.vue?vue&type=template&id=3f126fbf&scoped=true&"
import script from "./Compensation.vue?vue&type=script&lang=ts&"
export * from "./Compensation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f126fbf",
  null
  
)

export default component.exports